import { render, staticRenderFns } from "./WidgetWelcome.vue?vue&type=template&id=0927f6bc&scoped=true"
import script from "./WidgetWelcome.vue?vue&type=script&lang=ts"
export * from "./WidgetWelcome.vue?vue&type=script&lang=ts"
import style0 from "./WidgetWelcome.vue?vue&type=style&index=0&id=0927f6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0927f6bc",
  null
  
)

export default component.exports